<template>
  <div class="px-24 py-56 bg-surface-default-low">
    <div class="md:mx-auto md:max-w-[720px]">
      <h2 class="heading-2">
        {{ i18n(translations.title) }}
      </h2>

      <p class="body-2 text-static-default-low mb-32">
        {{ i18n(translations.subtitle) }}
      </p>

      <RevAccordionList class="-mx-20 md:mx-0" :has-external-borders="false">
        <RevAccordionItem
          v-for="(question, index) in questions"
          :key="index"
          collapsed="auto"
          :render-body="true"
          :wrapper-attrs="{ class: 'border-none' }"
        >
          <template #title>
            <h3 class="text-action-default-hi heading-3 mr-24">
              {{ question.title }}
            </h3>
          </template>

          <template #body>
            <p class="body-1 text-static-default-low">
              {{ question.answer }}
            </p>
          </template>
        </RevAccordionItem>
      </RevAccordionList>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevAccordionList } from '@ds/components/AccordionList'

import translations from './FaqSection.translations'

const i18n = useI18n()

const questions = [
  {
    title: i18n(translations.question1Title),
    answer: i18n(translations.question1Answer),
  },
  {
    title: i18n(translations.question2Title),
    answer: i18n(translations.question2Answer),
  },
  {
    title: i18n(translations.question3Title),
    answer: i18n(translations.question3Answer),
  },
  {
    title: i18n(translations.question4Title),
    answer: i18n(translations.question4Answer),
  },
]
</script>
